import React from "react";
import { ToastContainer } from "react-toastify";

export const ChatToastContainer = () => {
  return <ToastContainer limit={3} />;
};
